import { CookieOptions } from './types';

export const createCookieOptionsString = (options: CookieOptions = {}): string =>
    Object.entries(options).reduce((acc, [key, value]) => {
        if (value === undefined) return acc;

        if (key === 'expires' && value instanceof Date) {
            acc += `; ${key}=${value.toUTCString()}`;
        } else if (key === 'secure' && value === true) {
            acc += `; ${key}`;
        } else {
            acc += `; ${key}=${value}`;
        }
        return acc;
    }, '');

export const setCookie = (name: string, value: string, options?: CookieOptions): void => {
    const cookieOptions = createCookieOptionsString(options);
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${cookieOptions}`;
};

export const getCookie = (name: string): string | undefined => {
    const cookies = document.cookie.split('; ').map((cookie) => cookie.split('='));
    const foundCookie = cookies.find(([key]) => decodeURIComponent(key) === name);
    return foundCookie ? decodeURIComponent(foundCookie[1]) : undefined;
};

export const deleteCookie = (name: string, options?: CookieOptions): void => {
    setCookie(name, '', { ...options, maxAge: -1 });
};
